import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FilterContext = createContext();

export const useFilters = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilters must be used within a FilterProvider');
  }
  return context;
};

// Composant interne pour synchroniser l'URL avec les filtres (doit être à l'intérieur du Router)
const FilterSync = ({ setCategoryFilter }) => {
  const location = useLocation();

  // Synchroniser les paramètres URL avec le filtre au chargement
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');

    if (categoryParam) {
      setCategoryFilter(categoryParam);
    } else {
      // Si pas de paramètre category dans l'URL, réinitialiser le filtre
      setCategoryFilter('');
    }
  }, [location.search, setCategoryFilter]);

  return null;
};

export const FilterProvider = ({ children }) => {
  const [categoryFilter, setCategoryFilter] = useState('');
  const [priceRange, setPriceRange] = useState({ min: '', max: '' });
  const [maxPrice, setMaxPrice] = useState(100000); // Prix maximum par défaut

  const updateCategoryFilter = (categoryId) => {
    setCategoryFilter(categoryId);
  };

  const updatePriceRange = (range) => {
    setPriceRange(range);
  };

  const updateMaxPrice = (max) => {
    setMaxPrice(max);
    setPriceRange(prev => ({ ...prev, max: max.toString() }));
  };

  const clearFilters = () => {
    setCategoryFilter('');
    setPriceRange({ min: '', max: '' });
  };

  return (
    <FilterContext.Provider
      value={{
        categoryFilter,
        priceRange,
        maxPrice,
        updateCategoryFilter,
        updatePriceRange,
        updateMaxPrice,
        clearFilters,
      }}
    >
      <FilterSync setCategoryFilter={setCategoryFilter} />
      {children}
    </FilterContext.Provider>
  );
};
